import api from '../../Axios'; // Adjust path to your Axios instance if needed

// 🟢 STEP 2: Save Doctor Qualification
// Endpoint: /api/experts/doctor/qualification
export const saveDoctorQualification = async (formData: FormData) => {
  return api.post('/api/experts/doctor/qualification', formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // Crucial for file uploads/FormData
    },
  });
};